import { message, Modal } from 'antd';
import { seasonService } from 'content/service';
import { SeasonInterface } from 'type/seasonType';

interface SeasonHandlers {
  onClickDeleteButton: (record: SeasonInterface) => void;
}

const SeasonHandlers = (): SeasonHandlers => {
  const onClickDeleteButton = (record: SeasonInterface): void => {
    if (record.series) {
      message.warning(
        `이 시즌은 시리즈에 연결되어 있어 삭제할 수 없습니다. (시리즈 ID: ${record.series})`
      );
      return;
    }

    if (record.contents && record.contents.length > 0) {
      message.warning(
        `이 시즌에는 ${record.contents.length}개의 콘텐츠가 포함되어 있어 삭제할 수 없습니다.`
      );
      return;
    }

    Modal.confirm({
      title: '정말 삭제하시겠습니까?',
      content: '삭제하면 복구할 수 없습니다.',
      okText: '삭제',
      okType: 'danger',
      cancelText: '취소',
      onOk: async () => {
        try {
          await seasonService.delete(record.id);
          message.success('삭제가 완료되었습니다.');
          window.location.href = '/season/';
        } catch {
          message.error('삭제 중 오류가 발생했습니다.');
        }
      },
    });
  };

  return {
    onClickDeleteButton: onClickDeleteButton,
  };
};

export default SeasonHandlers;
